export enum ModalType {
  yesNo = 'yesNo',
  close = 'close',
}
